export class LadingSchesule {
    id: number;
    shipmentId: number;
    location: string;
    note: string;
    dateCreated: string;
    timeCreated: string;
    hubId: number;
    hubName: string;
    userId: number;
    userFullName: string;
    shipmentStatusId: number;
    shipmentStatusName: string;
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_crm_angular/src/app/models/ladingSchedule.model.ts